import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { ParamsType } from './types'
import { useDispatch, useSelector } from 'react-redux'
import { InitialState } from './types'
import * as actions from './actions'
import { GalleryItemType } from '../LessonPage/types'
import { BlockType } from '@famiryru/react-notion-renderer/src/types'
import moment from 'moment'
import * as profileActions from '../../containers/CoursePage/actions'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import ButtonFriendInvite from '../../components/ButtonFriendInvite'
import ButtonStartModule from '../../components/ButtonStartModule'
import ModalInvite from '../../components/ModalInvite'
import GalleryBlock from '../../components/GalleryBlock'
import TaskBlock from '../../components/TaskBlock'
import TimeWastedBlock from '../../components/TimeWastedBlock'
import AchievementsBlock from '../../components/AchievementsBlock'

export default () => {
  const [modalInviteFriend, setModalInviteFriend] = useState<boolean>(false)
  const [gallery, setGallery] = useState<GalleryItemType[]>([])
  const [notionTask, setNotionTask] = useState<BlockType[]>([])
  const [timestamp, setTimestamp] = useState<number>(0)
  const [first, setFirst] = useState<'gallery' | 'notion'>('gallery')
  const [continueModuleId, setContinueModuleId] = useState<string>('')

  const isMounted = useRef<boolean>(false)

  const { id, mid, sid } = useParams<ParamsType>()
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    achievements,
    moduleScreen,
    module,
    modules,
    progress,
    isFetching,
    isFetchingModule,
    isProcessUserState,
    error,
  } = useSelector(
    (state: { moduleScreenPage: InitialState }) => state.moduleScreenPage
  )

  const typeModuleScreen = moduleScreen?.type || null

  const simpleTaskProgress = progress?.modules.find(
    module => module.module_id === mid
  )?.simple_tasks_progress

  const lessonsProgress = progress?.modules.find(
    module => module.module_id === mid
  )?.progress.other

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchModuleScreen(id, mid, sid))
    dispatch(actions.fetchCourseUserState(id))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [sid])

  useEffect(() => {
    if (isMounted.current && moduleScreen) {
      const blockGallery = moduleScreen.blocks.find(
        block => block.type === 'gallery'
      )?.gallery?.images
      const blockNotionTask = moduleScreen.blocks.find(
        block => block.type === 'notion' && !block.tag
      )?.notion.notion_page_content
      const blockGalleryPosition = moduleScreen.blocks.find(
        block => block.type === 'gallery'
      )?.pivot?.position
      const blockNotionPosition = moduleScreen.blocks.find(
        block => block.type === 'notion' && !block.tag
      )?.pivot?.position

      if (blockGalleryPosition && blockNotionPosition) {
        if (blockGalleryPosition > blockNotionPosition) {
          setFirst('gallery')
        } else {
          setFirst('notion')
        }
      }

      setGallery(blockGallery || [])
      if (blockNotionTask) {
        setNotionTask([...JSON.parse(blockNotionTask)])
      } else {
        setNotionTask([])
      }
      dispatch(actions.fetchModule(id, mid))
      dispatch(actions.fetchModulesList(id))
    }
  }, [moduleScreen])

  useEffect(() => {
    if (typeModuleScreen === 'last' && module) {
      const endTime = module.user_module?.finished_at
      const startTime = module.user_module?.created_at
      if (endTime && startTime) {
        const duration = moment.duration(moment(endTime).diff(startTime))
        const seconds = duration.asSeconds()
        setTimestamp(seconds)
        const period = `${startTime},${endTime}`
        dispatch(actions.fetchAchievements(period))
      }
    }
  }, [module])

  useEffect(() => {
    if (continueModuleId && modules) {
      const findModule = modules.find(
        module => module.module_id === continueModuleId
      )
      const firstScreenId = findModule?.module_screens?.find(
        screen => screen.type === 'first'
      )?.module_screen_id

      const isJoined = findModule?.is_joined
      if (isJoined) {
        history.push(
          `/courses/${id}/modules/${continueModuleId}/screens/${firstScreenId}`
        )
      } else {
        dispatch(profileActions.joinModule(id, continueModuleId, firstScreenId))
      }
    }
  }, [continueModuleId])

  const bottomBlocks = () => {
    const blocks = []
    if (gallery.length) {
      blocks.push(
        <GalleryBlock style={{ marginBottom: 37 }} gallery={gallery} />
      )
    }
    if (notionTask.length) {
      blocks.push(
        <TaskBlock
          title={' '}
          showIcon={false}
          notionBlocks={notionTask}
          style={{ marginBottom: 37 }}
        />
      )
    }
    if (first === 'gallery') {
      return blocks.map((block, index) => (
        <div key={`block-${index}`}>{block}</div>
      ))
    } else {
      return blocks
        .reverse()
        .map((block, index) => <div key={`block-${index}`}>{block}</div>)
    }
  }

  const continueNextLevel = () => {
    if (modules) {
      const nextModuleId = modules.find(
        module =>
          (!module.is_finished &&
            module.is_joined &&
            module.is_available_on_time &&
            !module.is_blocked) ||
          (!module.is_finished &&
            module.can_join &&
            module.is_available_on_time &&
            !module.is_blocked) ||
          module.can_complete
      )?.module_id

      if (nextModuleId) {
        setContinueModuleId(nextModuleId)
      } else {
        history.push(`/courses/${id}`)
      }
    }
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        {!isMounted.current ||
        isFetching ||
        isFetchingModule ||
        isProcessUserState ||
        !typeModuleScreen ? (
          <LoadingPage />
        ) : (
          <div className={'module-screen'}>
            <div className={'module-screen__header'}>
              {typeModuleScreen === 'first' ? (
                <>
                  Это {module ? module.title : ''} лабиринта
                  <br />
                  <span>здесь тебя ждет:</span>
                </>
              ) : (
                <>
                  Ты молодец, прошел {module ? module.title : ''}
                  <br />
                  <span>Твои результаты:</span>
                </>
              )}
            </div>
            {typeModuleScreen === 'first' ? (
              <>
                <div className={'module-screen__row'}>
                  <div className={'module-screen__row-item'}>
                    <div className={'outer'}>
                      <span>Уроков</span>
                      <div className={'outer__count'}>
                        {module ? module.lessons_count : ''}
                      </div>
                    </div>
                  </div>
                  <div className={'module-screen__row-item'}>
                    <div className={'outer'}>
                      <span>Заданий</span>
                      <div className={'outer__count'}>
                        {simpleTaskProgress ? simpleTaskProgress.total : 0}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'module-screen__description'}>
                  Не хочешь проходить все в одиночку?
                </div>
                <div className={'module-screen__buttons'}>
                  <div className={'module-screen__buttons-item'}>
                    <ButtonFriendInvite
                      onClick={() => setModalInviteFriend(true)}
                    />
                  </div>
                  <div className={'module-screen__buttons-item'}>
                    {/* <ButtonParentInvite onClick={() => null} />*/}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={'module-screen__row last'}>
                  <div className={'module-screen__row-item'}>
                    <div className={'outer'}>
                      <span>
                        Уроков
                        <br />
                        пройдено
                      </span>
                      <div className={'outer__count'}>
                        {lessonsProgress
                          ? `${lessonsProgress.completed}/${lessonsProgress.total}`
                          : ''}
                      </div>
                    </div>
                  </div>
                  <div className={'module-screen__row-item'}>
                    <div className={'outer'}>
                      <span>
                        Заданий
                        <br />
                        завершено
                      </span>
                      <div className={'outer__count'}>
                        {simpleTaskProgress
                          ? `${simpleTaskProgress.completed}/${simpleTaskProgress.total}`
                          : ''}
                      </div>
                    </div>
                  </div>
                  <div className={'module-screen__row-item'}>
                    <div className={'outer'}>
                      <span>
                        Достижений
                        <br />
                        получено
                      </span>
                      <div className={'outer__count'}>
                        {achievements ? achievements.length : 0}
                      </div>
                    </div>
                  </div>
                </div>
                <TimeWastedBlock
                  title={
                    <>
                      Времени на выполнение уровня
                      <br />
                      затрачено
                    </>
                  }
                  timestamp={timestamp}
                  style={{ marginBottom: 35 }}
                />
                {achievements && achievements.length ? (
                  <AchievementsBlock
                    title={' '}
                    achievements={achievements}
                    countOpened={achievements.length}
                    hideAllCount={true}
                    style={{ marginBottom: 40 }}
                  />
                ) : null}
              </>
            )}
            {bottomBlocks()}
            {typeModuleScreen === 'first' ? (
              <ButtonStartModule
                title={'Начать прохождение уровня'}
                styles={{ marginBottom: 30 }}
                onClick={() => history.push(`/courses/${id}/modules/${mid}/`)}
              />
            ) : (
              <ButtonStartModule
                title={'Перейти к следующему уровню'}
                styles={{ marginBottom: 30 }}
                onClick={continueNextLevel}
              />
            )}
          </div>
        )}
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <ModalInvite
        modal={modalInviteFriend}
        typeInvite={'friend'}
        isReverse={false}
        alertDescription={'Поделитесь ей с другом!'}
        onClose={() => setModalInviteFriend(false)}
      />
      <Footer />
    </>
  )
}
